module.exports = __webpack_public_path__ + "static/media/icon-13w.689b8e92.svg";